import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { VideoChatRequest } from '../../model/video-chat/video-chat-request';

@Injectable({
  providedIn: 'root'
})
export class VideoChatService {

  private readonly getVideoChatRequestPendienByPatientEndPoint: string = '/videoChat/getVideoChatRequestPendienByPatient/';
  private readonly getVideoChatUrlEndPoint: string = '/videoChat/getVideoChatUrl/';

  constructor( private dataService: DataService ) { }

  async getVideoChatUrl(): Promise<string> {
    return await this.dataService.get<string>
    (this.getVideoChatUrlEndPoint, {}).toPromise();
  }

  async getVideoChatRequestPendienByPatient(patientId: number): Promise<VideoChatRequest> {
    const param = { patientId: patientId };
    return await this.dataService.get<VideoChatRequest>
    (this.getVideoChatRequestPendienByPatientEndPoint, param).toPromise();
  }

}
